import { createIdleLogout } from "@/hooks/createIdleLogout";
import { useClinicianAuthStore } from "@/stores/clinicianAuthStore";

export const useIdleLogout = createIdleLogout(useClinicianAuthStore, "/clinician/login");
